export default __webpack_public_path__ + "static/media/pro-elevate-bpn-banner-1.12e4a5a1.jpg";